<form class="section-editor-form" style="padding: 2em;" [formGroup]="formG1">


	<triv-input [fGroup]="formG1" [data]="myInputs.sparteBezeichnung"></triv-input>
	<triv-input [fGroup]="formG1" [data]="myInputs.sparteBeshreibung"></triv-input>

	
	<div style="margin-top: 4em; display: flex; flex-flow: row; justify-content: flex-end; gap: 2em;">

		<button mat-raised-button 
			*ngIf="!section.sparteId"
			(click)="cancel()">Abbrechen</button>

		<button mat-raised-button 
			[disabled]="formG1.pristine"
			(click)="reset()">Zurücksetzen</button>

		<button mat-raised-button color="primary" 
			(click)="save()" 
			[disabled]="!formG1.valid || formG1.pristine">Speichern</button>

	</div>

</form>
